import {STATUS_SHOWING} from "VueApps/comments/services/statusTypes";

export const isCommentShowing = (comment) => {
    return comment.status.type === STATUS_SHOWING;
};
